export default __webpack_public_path__ + "static/pulse_customer_maintenance-dc8f69f27aadb09b815f7f4a09dd6246.jpeg";